import { axiosRequest } from './../../service/axios';

export const getList = (params) => {
  const url = 'fs/items/list';
  const options = {
    method: 'get',
  };
  const axiosData = {
    url,
    params,
    options,
  };
  return axiosRequest(axiosData);
};

export const getItemBreadcrumbs = (id) => {
  const url = `fs/items/${id}/breadcrumbs`;
  const options = {
    method: 'get',
  };
  const axiosData = {
    url,
    options,
  };
  return axiosRequest(axiosData);
};

export const searchFiles = (params) => {
  const url = 'fs/items/search';
  const options = {
    method: 'get',
  };
  const axiosData = {
    url,
    options,
    params,
  };
  return axiosRequest(axiosData);
};

export const accessManage = (params) => {
  const url = 'fs/directories/access-manage';
  const options = {
    method: 'get',
  };
  const axiosData = {
    url,
    options,
    params,
  };
  return axiosRequest(axiosData);
};

export const updateAccessManage = (data) => {
  const url = 'fs/directories/access-manage';
  const axiosData = {
    url,
    data,
  };
  return axiosRequest(axiosData);
};

export const storeDirectory = (data) => {
  const url = 'fs/directories/store';
  const axiosData = {
    url,
    data,
  };
  return axiosRequest(axiosData);
};

export const renameDirectory = (id, data) => {
  const url = `fs/directories/${id}/rename`;
  const axiosData = {
    url,
    data,
  };
  return axiosRequest(axiosData);
};

export const renameFile = (id, data) => {
  const url = `fs/files/${id}/rename`;
  const axiosData = {
    url,
    data,
  };
  return axiosRequest(axiosData);
};

export const getDirectoryDetails = (id) => {
  const url = `fs/directories/${id}`;
  const options = {
    method: 'get',
  };
  const axiosData = {
    url,
    options,
  };
  return axiosRequest(axiosData);
};

export const getFileDetails = (id) => {
  const url = `fs/files/${id}`;
  const options = {
    method: 'get',
  };
  const axiosData = {
    url,
    options,
  };
  return axiosRequest(axiosData);
};

export const getDirList = (params) => {
  const url = 'fs/directories/list';
  const options = {
    method: 'get',
  };
  const axiosData = {
    url,
    options,
    params,
  };
  return axiosRequest(axiosData);
};

export const moveItems = (data) => {
  const url = 'fs/items/bulk-move';
  const axiosData = {
    url,
    data,
  };
  return axiosRequest(axiosData);
};

export const bulkDelete = (data) => {
  const url = 'fs/items/bulk-delete';
  const axiosData = {
    url,
    data,
  };
  return axiosRequest(axiosData);
};

export const authorizeDownload = (id) => {
  const url = `fs/files/${id}/authorize-download`;
  const axiosData = {
    url,
  };
  return axiosRequest(axiosData);
};

export const authorizeOcrDownload = (id) => {
  const url = `fs/files/${id}/authorize-ocr-download `;
  const axiosData = {
    url,
  };
  return axiosRequest(axiosData);
};

export const getTags = () => {
  const url = 'fs/files/tags';
  const options = {
    method: 'get',
  };
  const axiosData = {
    url,
    options,
  };
  return axiosRequest(axiosData);
};

export const setTags = (id, data) => {
  const url = `fs/files/${id}/tag`;
  const axiosData = {
    url,
    data,
  };
  return axiosRequest(axiosData);
};

export const googleShare = (id) => {
  const url = `fs/files/${id}/google-share`;
  const axiosData = {
    url,
  };
  return axiosRequest(axiosData);
};

export const preview = (id) => {
  const url = `fs/files/${id}/preview-list`;
  const options = {
    method: 'get',
  };
  const axiosData = {
    url,
    options,
  };
  return axiosRequest(axiosData);
};

export const authorizePreview = (url) => {
  const axiosData = {
    url,
  };
  return axiosRequest(axiosData, true);
};
